













































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import TeacherMainteTab from "../../components/TeacherMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, UserScorableRange } from "../../modules/teacher/UserScorableRangeList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  user_scorable_ranges: UserScorableRange[]
  fields: any[]
  perPage: number
  totalCount: number
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "teacher-mainte-tab": TeacherMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 3,
      condition: new SearchCondition(),
      user_scorable_ranges: new Array<UserScorableRange>(),
      fields: [
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "user_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_codes", label: "コース", class: 'text-center b-table-th-td'},
        {key: "campus_codes", label: "キャンパス", class: 'text-center b-table-th-td'},
        {key: "class_codes", label: "クラス", class: 'text-center b-table-th-td'},
        {key: "subject_codes", label: "科目", class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center', thStyle: {width: "100px"}},
      ],
      perPage: 100,
      totalCount: 0,
      isShowPagination: false,
      isAllDeleteChecked: false,
      errors: [],
    });

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.user_scorable_ranges.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.user_scorable_ranges.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/user_scorable_range_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/teacher/user_scorable_range_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `採点権限マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/user_scorable_range_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.user_scorable_ranges = response.data.user_scorable_ranges.map((x: any) => new UserScorableRange(x)); 
        state.totalCount = state.user_scorable_ranges.length == 0 ? 0 : state.user_scorable_ranges[0].full_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      searchButtonClick,
      clearCondition,
      allSelectChanged,
      deleteMst,
      changePage,
      download,
    };
  }
});
